module.exports = __webpack_public_path__ + "img/slick.2726d00a.png";